import React, { useContext } from 'react';
import { SimpleDialog, Typography, styled } from '@nextiva/next-ui-components';
import {
  actionTypes,
  LicensesContext,
} from 'containers/pages/BillingLicenses/licensesContext';

const StyledSimpleDialog = styled(SimpleDialog)`
  z-index: 1400;
`;
const StyledDialogText = styled(Typography)`
  width: 349px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;

interface ISaveChangesModal {
  onSaveHandler: (
    event: React.ChangeEvent<HTMLInputElement>,
    togglePurchaseLicenseModal: boolean,
  ) => void;
}

export const SaveChangesModal = ({ onSaveHandler }: ISaveChangesModal) => {
  const { dispatch } = useContext(LicensesContext);

  const onCancelButtonClick = (): void => {
    dispatch({
      type: actionTypes.TOGGLE_SAVE_CHANGES_MODAL,
    });
  };
  const onSaveButtonClick = (event): void => {
    onSaveHandler(event, true);
    dispatch({
      type: actionTypes.TOGGLE_SAVE_CHANGES_MODAL,
    });
  };

  return (
    <StyledSimpleDialog
      data-testid="PlatformAdminUI-EditAssignmentDrawer-SaveChangesModal"
      dialogProps={{
        'aria-label': 'Save Changes',
        disablePortal: true,
        disableScrollLock: true,
      }}
      cancelButtonProps={{
        onClick: onCancelButtonClick,
        'data-testid':
          'PlatformAdminUI-EditAssignmentDrawer-SaveChangesModal-CancelButton',
      }}
      cancelText="Cancel"
      confirmButtonProps={{
        color: 'primary',
        onClick: onSaveButtonClick,
        'data-testid':
          'PlatformAdminUI-EditAssignmentDrawer-SaveChangesModal-SaveButton',
      }}
      confirmText="Yes, save changes"
      title="Save Changes?"
      open
    >
      <StyledDialogText variant="body2">
        You have unsaved changes that have been made.
      </StyledDialogText>
      <StyledDialogText variant="body2">
        Are you sure you want to take this action?
      </StyledDialogText>
    </StyledSimpleDialog>
  );
};
